import { CMSResolver } from '../providers/cms.resolver';
import { Directive, Input, AfterViewInit, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cms]'
})
export class CMSDirective implements AfterViewInit {
  @Input('cms') path: string;

  constructor(
    private page: CMSResolver,
    private viewContainer: ViewContainerRef
    ) {
  }

  ngAfterViewInit() {
    let content = CMSResolver.cms;
    this.path.split('.').forEach(node => {
      content = content[node];
    });
    this.viewContainer.element.nativeElement.innerHTML = content;
  }
}
